<template>
  <div class="feed">
    <div class="container">
      <Navbar />
      <AdminPlayers />
      <Footer />
    </div>
    <Notification />
  </div>
</template>


<script>
import Navbar from '@/components/Navigation';
import AdminPlayers from '@/components/AdminPlayers';
import Footer from '@/components/FooterInside';
import Notification from '@/components/Notification';

export default {
  name: 'feed',
  components: {
    Navbar,
    AdminPlayers,
    Footer,
    Notification
  },
  data(){
    return{
    }
  },
  created(){
    if(localStorage.token){
      
      this.$parse.User.become(localStorage.token)
      
      .then((res) => {
        if (res.id == '') {
          this.$router.push('/')
        }
      })
      .catch((error) => {
        this.logOut()
      });

    } else {
      this.$router.push('/')
    }
  },
  methods: {
    logOut(){
      localStorage.objectId = ''
      localStorage.token = ''
      const user = this.$parse.User.logOut()
      if (user) {
        this.$router.push('/')
      }
    }
  }
}
</script>
